import { Component, OnInit, HostListener} from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { CommonDbService } from '../shared/services/common-db.service';
import { TimelineService } from '../shared/services/timeline.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Configuration } from '../../app.constants';
import { Router } from '@angular/router'
import * as io from 'socket.io-client';
import * as moment from 'moment';
// import { format } from 'path';
// import { error } from 'util';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { ImageGalleryComponent } from '../../shared/components/image-gallery/image-gallery.component';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';

import { AssociateService } from '../../associate/shared/services/associate.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { WorkgroupService } from '../../work-groups/workgroup-services/workgroup.service';
import { SocketService } from 'app/shared/services/socket.service';


@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./_feed.component.scss'],
})
export class FeedComponent implements OnInit {
    public socket: any;
    public socketnot: any;
    // public actionSocket:any;
    // public actions:any=[]
    public timelineData: Array<any> = [];
    public user: any;
    public notifications:any=[];
    public associate: any;
    // public tabpane='Action Center'
    public totalFeed = 0;
    public search='';
    public status="";
    public todayUpdateCount=0;
    public isNewNotification = false;
    public serverApiUrl;
    public isLoading = true;


    //power search
    public associates = [];
    public organizations= [];
    public sites = [];
    public teams = [];
    public lists = [];
    public workgroups = [];

    public searchText: string;
    public shouldSearch: Boolean = true;
    public associateQuery = {
        search : {
            'active': true,
            'personalInformation.fullName': { '$regex': '', '$options': 'i' },
        },
        sort: { 'personalInformation.fullName': 1 },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
      };
    public siteQuery = {
        search : {
            'active': true,
            'siteDetails.siteName': { $regex: '', $options: 'i' }
        },
        sort: {
            'siteDetails.siteName': 1
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
      };

    public organizationQuery = {
        search : {
            'active': true,
            'company.companyName': { $regex: '', $options: 'i' }
        },
        sort: {
            'company.companyName': 1
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1
        }
    };

    constructor( public mobileNav: MobileNavService,
        public timelineService: TimelineService,
        public commonDbService: CommonDbService,
        public config: Configuration,
        public authService: AuthService,
        public router:Router,
        public dialog: MatDialog,
        public ionicAngular4Cache: IonicAngular4CacheService,
        public assc: AssociateService,
        public organizationService: OrganizationService,
        public workGroupService: WorkgroupService,
        private socketService:SocketService

    ) {}

    ngOnInit() {
        this.serverApiUrl = this.config.StaticImageUrl;
        this.user = this.authService.user;
        this.assc.getAssociate(this.user.associateId).subscribe(associates => {
            this.associate = associates['data'][0];
            this.getTimelineData();
            // this.socketListner();
            if (!this.associate['active'] && this.associate['_id'] === this.user.associateId) {
                this.authService.logout();   
            }
        });
        // this.socketnot = io(this.config.SocketUrl);
        // this.actionSocket = io(this.config.SocketUrl);
        // this.socket = io(this.config.SocketUrl);


        // this.socket.on(`new-feed-item-${this.user.associateId}`, function (data) {
        //     if (data.status==='Published'){
        //         this.timelineData.unshift(data);
        //     }
        //     this.todayUpdateCount++;
        // }.bind(this));

        this.getAllNotifications();
        // this.getAllActions();

        
    }

    socketListner(){
        this.socketService.newFeedObs.subscribe(feed=>{
            if(feed !== undefined){
                if (feed.status==="Published"){
                    this.timelineData.unshift(feed);
                }
                this.todayUpdateCount++;    
            }
        });

        this.socketService.notificationObs.subscribe(notification=>{
            if(notification !== undefined){
                if (this.notifications[0] === undefined ){
                    this.notifications = [{day: 'Today', notifications: []}]
                }else if (this.notifications[0].day !== 'Today'){
                    this.notifications.unshift({day: 'Today', notifications: []})
                }
                this.notifications[0].notifications.unshift(notification);
                this.isNewNotification = true;    
            }
        });
    }

    getTimelineData() {
        this.commonDbService.getFeed(this.associate.timelineNews, this.timelineData.length, 10).subscribe((data) => {
            // if(data){
            this.isLoading = false;
            this.timelineData = data['data'];
            // this.timelineData.reverse();
            this.totalFeed = data['length']
            this.timelineData.forEach(news => {
                if (moment(news.lastUpdated.date).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) {
                    this.todayUpdateCount++;
                }
            })
        }, (error) => {
            this.isLoading = false;
            this.ionicAngular4Cache.getItemOld('timeline').then(data =>  {
                if (data) {
                    this.timelineData = data['data'];
                    this.totalFeed = data['length'];
                }
            });
        });
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }


    getAllNotifications(){
        var current=moment();
        var yesterday=moment().add('days',-1);

        this.timelineService.getAllNotifications(this.user.associateId).subscribe(data1 => {
            var datas=Object.assign([],data1)
            var obj={day:'',notifications:[]};
            datas.filter(data=>{
                if(current.format('DD MMM YYYY')=== moment(data.time).format('DD MMM YYYY')){
                    if(obj.day!== 'Today'){
                        if(obj.notifications.length)
                            this.notifications.push(Object.assign({},obj))
                        obj.day = 'Today'
                        obj.notifications = [];
                        obj.notifications.push(data)
                    }else    
                    obj.notifications.push(data)
                }
                else if(yesterday.format('DD MMM YYYY') === moment(data.time).format('DD MMM YYYY')){
                    if (obj.day !== 'Yesterday'){
                        if (obj.notifications.length)
                            this.notifications.push(Object.assign({}, obj))
                        obj.day = 'Yesterday'
                        obj.notifications = [];
                        obj.notifications.push(data)
                    }
                    else
                        obj.notifications.push(data)
                }
                else if (obj.day !== moment(data.time).format('DD MMM YYYY')){
                    if (obj.notifications.length)
                        this.notifications.push(Object.assign({}, obj))
                    obj.day = moment(data.time).format('DD MMM YYYY')
                    obj.notifications = [];
                    obj.notifications.push(data)
                }
                else{
                    obj.notifications.push(data)
                }
            })
            if ( obj.day) {
                this.notifications.push(Object.assign({}, obj))
            } else {
                this.notifications = [{day: 'Today', notifications: []}];
            }
            })

        // this.socketnot.on(`notifications-${this.user.associateId}`, function (data) {
        //     if (this.notifications[0].day !== 'Today'){
        //         this.notifications.unshift({day: 'Today', notifications: []})
        //     }
        //     this.notifications[0].notifications.unshift(data);
        //     this.isNewNotification = true;
        // }.bind(this));

    }
    concatenateApiUrl(imageUrl) {
        return this.serverApiUrl + ' ' + imageUrl;
    }

    imageDisplayPopUp(images, index) {
        console.log(" ==== img === " ,images)
        if (window.innerWidth < 768){
            // mobile
            const dialogRef = this.dialog.open(ImageGalleryComponent, {
                width: 'auto',
                height: 'auto',
                data: { 
                    images: images,
                    index:index 
            }
                    // data:{images: ["assets/img/gallery/img1.jpg","assets/img/gallery/img13.jpg","assets/img/gallery/img17.jpg"]}
              });
            }else{
                const dialogRef = this.dialog.open(ImageGalleryComponent, {
                    width: 'auto',
                    height: 'auto',
                    data: { 
                        images: images,
                        index:index
                     }
                        // data:{images: ["assets/img/gallery/img1.jpg","assets/img/gallery/img13.jpg","assets/img/gallery/img17.jpg"]}
                  });
            }
    }

    saveSearchHistory(name, category, id, extrainfo?) {
        for (let i = 0; i < 5 ; i++) {
            if (this.associate['powerSearchHistory'][i].id === id) {
                return;
            }
        }

        this.associate['powerSearchHistory'].unshift({name: name, id: id, componentType: category, extrainfo: extrainfo});
        // this.associate['powerSearchHistory'] = this.associate['powerSearchHistory'].splice(0, 5);
        this.assc.updateAssociate(this.associate).subscribe(res => {}, error => {
        })
    }

    clickDropDown(category, id, extraId?) {
        this.shouldSearch = false;
        if (category === 'associate') {
            this.router.navigate(['/home/associate/profile/view', id]);
        } else if (category === 'organization') {
            this.router.navigate(['/home/organization/profile/view', id]);
        } else if (category === 'sites') {
            this.router.navigate(['/home/organization/site-profile/view', id]);
        } else if (category === 'workgroup') {
            this.router.navigate(['/home/working-group/profile/', id]);
        } else if (category === 'teams') {
            this.router.navigate(['/home/organization/team-profile/view/', id, extraId]);
        } else if (category === 'list') {
            this.router.navigate(['/home/list/profile', id]);
        }
        this.associates = [];
        this.organizations = [];
        this.sites = [];
        this.teams = [];
        this.lists = [];
        this.workgroups = [];
    }

    intialAssociates(event) {
        this.shouldSearch = true;
        if (event !== '' && this.shouldSearch) {
            // get associates
            this.associateQuery.search['personalInformation.fullName'] = { $regex: this.searchText, $options: 'i' };
            this.assc.search(
                this.associateQuery.pagination.pageIndex,
                this.associateQuery.pagination.pageSize,
                this.associateQuery.search,
                this.associateQuery.sort).then((data) => {
                this.associates = data['data'];
            }, (error) => {
            });
            // get organizations
            this.organizationQuery.search['company.companyName'] = { $regex: this.searchText, $options: 'i' };
            this.organizationService.search(
                this.organizationQuery.pagination.pageIndex,
                this.organizationQuery.pagination.pageSize,
                this.organizationQuery.search,
                this.organizationQuery.sort).then((data) => {
                    this.organizations = data['data'];
                }, (error) => {
                });
            // get sites
            this.siteQuery.search['siteDetails.siteName'] = { $regex: this.searchText, $options: 'i' };
            this.organizationService.searchSites(
                this.siteQuery.pagination.pageIndex,
                this.siteQuery.pagination.pageSize,
                this.siteQuery.search,
                this.siteQuery.sort
            ).subscribe((data) => {
                this.sites = data['data'];
            }, (error) => {
            });
              // get WorkGroups
              this.workGroupService.getWorkGroupsByName(this.searchText).subscribe((data) => {
                 this.workgroups = data['data'];
              }, (error) => {
              });

              // get Teams
              this.organizationService.teamSearch(this.searchText).subscribe((data) => {
                    this.teams = data['data'];
              }, (error) => {
              });
              // get lists of this associate
              this.assc.getAssociate(this.authService.user.associateId).subscribe((data) => {
                this.lists = data['data'][0].listManagment;
              }, (error) => {
              });
        }
    }



    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
            let h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';
            var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
            if (percent === 100 && this.timelineData.length < this.totalFeed && !this.isLoading) {
                this.isLoading = true;
                this.commonDbService.getFeed(this.associate.timelineNews, this.timelineData.length, 10).subscribe( (data) => {
                    this.isLoading = false;
                    // console.log('data' , data['data'])
                    this.timelineData = this.timelineData.concat(data['data']);
                    // console.log('scroll data', this.timelineData.length, this.totalFeed)
                })
            }
    }

    rerouteToNotification(urlToRoute) {
        this.router.navigate([urlToRoute]);
    }
}
